module.exports = __webpack_public_path__ + "static/media/Group54.0d906e75.svg";